import type { AgentActionItem, AgentDashboardResponse } from 'types/agent-dashboard';

import { apiClient } from 'utils/api';

export const fetchAgentDashboard = async (signal?: AbortSignal): Promise<AgentDashboardResponse> => {
  const { data } = await apiClient.get<AgentDashboardResponse>('/agent-dashboard', { signal });
  return data;
};

export const updateAgentActionItem = async (id: string, status: AgentActionItem['status']): Promise<AgentActionItem> => {
  const { data } = await apiClient.patch<AgentActionItem>(`/agent-dashboard/action-items/${encodeURIComponent(id)}`, { status });
  return data;
};
